import React, { memo } from 'react';

const ContactPage = () => {
  return <div>Under construction</div>;
}

export default memo(ContactPage);
